
import * as React from "react";
import {ModelyearDto, TypefamilyDto} from "../../../services/Client";
import {ITypefamilyMap} from "../../../redux/reducers/generalReducer";
import SelectField, {OptionValue, SelectedValue, SelectFieldValueComparator} from "../../../components/SelectField";

export class GroupsUtils {

    static renderSelectField = (
        header: string,
        placeholder: string,
        dataSource: OptionValue[],
        values: OptionValue[],
        rendererKey: (option: OptionValue, index?: number) => string,
        clearable: boolean,
        valueComparator?: SelectFieldValueComparator,
        style?: React.CSSProperties,
        onChange?: (selectedValue?: OptionValue | SelectedValue[] | undefined, selectedIndex?: number | undefined) => void,
        disabled?: boolean,
        readonly?: boolean
    ): JSX.Element => (
        <div style={style}>
            <b>{header}: </b>
            <SelectField
                placeholder={placeholder}
                multi={true}
                searchable={true}
                disabled={disabled}
                readonly={readonly}
                clearable={clearable}
                dataSource={dataSource}
                valueComparator={valueComparator}
                value={values}
                rendererKey={rendererKey}
                onChange={onChange}
            />
        </div>
    )

    /**
     *
     * @param typefamilies
     *
     * @returns a sorted array with typefamilies identifiers without duplicates
     */
    static mapAssignedTypefamilies = (typefamilies: TypefamilyDto[]) => {
        return typefamilies
            ? Array.from(new Set(typefamilies.sort((a, b) => {
                // @ts-ignore
                return a.sortSequence - b.sortSequence;
            }).map(tf => tf.key)))
            : [];
    }

    /**
     * Map and sort typefamily datasource based on selected modelyears
     * @returns an array with typefamily identifierS without duplicates
     */
    static getTypefamilyDataSource = (typefamiliesMap: ITypefamilyMap, modelyears: ModelyearDto[]): string[] => {
        const tfNameSeqSortMap: Map<number, string> = new Map();

        Object.keys(typefamiliesMap).forEach((key: string) => {
            if (modelyears.find(a => a.mj1 === key)) {
                const elements: TypefamilyDto[] =
                    typefamiliesMap &&
                        typefamiliesMap[key] ?
                        typefamiliesMap[key].elements as TypefamilyDto[] : [];

                elements.forEach((item: TypefamilyDto) => {
                    tfNameSeqSortMap[item.sortSequence!] = item.key;
                });
            }
        });

        return Object.keys(tfNameSeqSortMap).map(key => tfNameSeqSortMap[key]);
    }

    static getSortedTypefamilies = (typefamilyMap: ITypefamilyMap | undefined) => {
        const typefamilies: TypefamilyDto[] = [];

        if (typefamilyMap) {
            Object.keys(typefamilyMap).forEach((key: string) => {
                if (typefamilyMap[key] && typefamilyMap[key].elements) {
                    // @ts-ignore already checked
                    typefamilies = typefamilies.concat(typefamilyMap[key].elements);
                }
            });
        }

        typefamilies.sort((a, b) => {
            // @ts-ignore
            return a.sortSequence - b.sortSequence ||
                // @ts-ignore
                a.modelyear.mj4 - b.modelyear.mj4;
        });

        return typefamilies;
    }
}



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/GroupsUtils.tsx